import { Divider, Tag } from 'antd'
import { CloseIcon } from 'assets/svg/icon'
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { changeQuantity } from 'redux/actions'
import { getAttachment } from 'utils/attachment'
import { addToCart, subtractItem, deleteSubtractItem } from 'utils/cart'

function CartItem({item, locale, currency}) {

  const dispatch = useDispatch();

  const addItemToCart=(e)=>{
    if (item?.product?.stock){
        e.preventDefault();
        if ( item?.product?.stock>item?.quantity){
          addToCart(item?.product);
          dispatch(changeQuantity(1))
        }
    }
  }
  const subtractItemFromCart=(e)=>{
      e.preventDefault();
      subtractItem(item?.product)
      dispatch(changeQuantity(-1))
  }

  const deleteProduct = (e) => {
    e.preventDefault();
    deleteSubtractItem(item.product);
    dispatch(changeQuantity(0))
  }

  return (
    item?.quantity>0 && <div>
      <div className="d-flex align-items">
        <div style={{width: '64px', height: '64px'}} onClick={()=>localStorage.setItem('chosen-cart-item', JSON.stringify(item))}>
          <Link to={APP_PREFIX_PATH+'/products/'+item.id}>
            <img src={item?.product?.images?.length ? getAttachment(item?.product?.images[0].id) : '/img/productsFallback.svg'} alt='' style={{width: '64px', height: '64px', objectFit: 'cover', borderRadius: '3px'}}/>
          </Link>
        </div>
        <div className="pl-3 w-100 ">
          <div className="d-flex justify-content-between mb-1">
            <h4 className="m-0 text-black">{locale==='en' ? item?.product.nameEng : item?.product.nameAr}</h4>
            <h4 className="m-0 text-black"> {currency} {(item?.price*item?.quantity).toFixed(3)}</h4>
          </div>
          <p style={{fontSize:'16px', color:'#616161', marginBottom:'4px', lineHeight:'22px'}}>
            {item?.product?.comment}
          </p>
          <div className="d-flex flex-wrap">
            {item?.product?.productAddons?.length>0 && item?.product?.productAddons?.map(addon=><div key={addon?.id}>
              {addon.modifiers?.length>0 && addon.modifiers?.map(modifier=>{
                if (addon?.chosenModifiers?.includes(modifier.id)){
                  return <Tag key={modifier?.id} className='font-bold mb-2' color={'#F5F5F5'} style={{color:'rgba(31, 31, 31, 0.75)', borderRadius:'100px'}}>{locale==='en' ? modifier?.nameEng : modifier.nameAr}</Tag>
                }
              })}
            </div>)}
          </div>
          <div className='counterContainer'>
            <img onClick={subtractItemFromCart} src='/img/minusItem.svg' alt='minus' className='changeQuantity'/>
            <div className='mx-3 text-black font-16'>{item?.quantity}</div>
            <img onClick={addItemToCart} src='/img/plusItem.svg' alt='plus' className={`changeQuantity ${item?.quantity===item?.product?.stock && 'disabledSoldOutCounter'}`}/>
            <i onClick={deleteProduct} className='close-icon'> {CloseIcon} </i>
          </div>
        </div>
      </div>
      <Divider className='mt-3 mb-3'/>
    </div>
  )
}

export default CartItem